module.exports = __webpack_public_path__ + "img/close1.cad33508.svg";